import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PopupsTable from "../components/PopupsTable";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PopupsPage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Popuplar" />
      <div className="dashboard-main active">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <PopupsTable />
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default PopupsPage;

